import { fetchConToken } from '../utils/fetch.ts';


export const find = async (id: number = 0, nombre_o_email: string = "", rol_id: number = 0, estado:string = "0", comunas: string = "" ) => {
  try {

    const resp = await fetchConToken("usuarios/find?nombre_o_email=" + nombre_o_email + "&rol_id=" + rol_id + "&estado=" + estado + "&id=" + id+"&comunas="+comunas, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const create = async (rut: string, email: string, nombre: string, apellido: string, roles: [],  comunasCoordinador: [], comunasUsuComunal: []) => {
  try {
    let data = {
      rut: rut,
      email: email,
      nombre: nombre,
      apellido: apellido,
      roles: roles,
      comunascoordinador: comunasCoordinador,
      comunasusucomunal: comunasUsuComunal
    }

    const resp = await fetchConToken("usuarios/create/", data, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const update = async (id: number, email: string, nombre: string, apellido: string,  roles: [],  comunasCoordinador: [], comunasUsuComunal: []) => {
  try {
    let data = {
      id: id,
      email: email,
      nombre: nombre,
      apellido: apellido,
      roles: roles,
      comunascoordinador: comunasCoordinador,
      comunasusucomunal: comunasUsuComunal
    }

    const resp = await fetchConToken("usuarios/update/", data, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const desactivar = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/deactivate", { id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const activar = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/activate", { id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const eliminar = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/eliminar", { id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};



export const listadoUsuarios = async() => {
  try {
    const resp = await fetchConToken("usuarios/listado-usuarios", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const enviarPassword = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/enviar-password", { id }, "POST"); 
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const reestablecerPassword = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/reestablecer-password", { id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};


export const actualizarUsuarios = async (usuarios) => {
  try {
    const resp = await fetchConToken("usuarios/actualizar-usuario",  usuarios , "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const obtenerAdministradores = async (activo: string = "") => {
  try {
    let url = "usuarios/obtener-administradores";
    if (activo) {
      url += `?activo=${activo}`;
    }
    const resp = await fetchConToken(url, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const crearAdministrador = async (email: string, rut: number, dv: string, nombre: string, apellido: string, password: string, roles: number[]) => {
  try {
    const data = {
      email,
      rut,
      dv,
      nombre,
      apellido,
      password,
      roles
    };
    const resp = await fetchConToken("usuarios/crear-administrador", data, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const habilitarAdministrador = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/habilitar-administrador", { id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const deshabilitarAdministrador = async (id: number) => {
  try {
    const resp = await fetchConToken("usuarios/deshabilitar-administrador", { id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const obtenerCoordinadores = async () => {
  try {
    const resp = await fetchConToken("usuarios/obtener-coordinadores", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export default { find, create, update, desactivar, activar, eliminar, listadoUsuarios, obtenerAdministradores, crearAdministrador, habilitarAdministrador, deshabilitarAdministrador, enviarPassword, actualizarUsuarios, obtenerCoordinadores, reestablecerPassword };





